module.exports = __webpack_public_path__ + "static/media/civicheroes.30d4a68a.png";